<section class="hvac-delete-account-page">
    <h1 class="hvac-h2 hvac-rhythm-3">{{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.TITLE' | translate}}</h1>
    <p class="hvac-h6 hvac-delete-account-terms">{{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.NOTE' | translate}}</p>


    <form [formGroup]="accountDeletionForm">
        <div class="hvac-delete-account-container">
            <div class="hvac-col-xs-12 hvac-col-md-6 hvac-delete-account-col">
                <div class="hvac-form-field">
                    <utc-input [inputControl]="accountDeletionForm.controls.email" [disabledInput]="true"
                        label="{{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.EMAIL' | translate}}">
                    </utc-input>
                </div>

                <div class="hvac-form-field">
                    <utc-input [inputControl]="accountDeletionForm.controls.userId" [disabledInput]="true"
                        label="{{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.USERID' | translate}}">
                    </utc-input>
                </div>
            </div>

            <div class="hvac-delete-account-confirmation-checkbox">
                <utc-checkbox
                    [checked]="isConfirmCheckboxSelected"
                    (change)="changeConfirmationControl($event)"
                    class="hvac-label-sm">
                </utc-checkbox>
                <p class='hvac-h6 hvac-delete-account-terms hvac-terms-label'>{{ 'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.CONFIRM_DELETION' | translate  }}</p>
            </div>
        </div>

        <hr />

        <div class="hvac-delete-account-form-foot-container">
            <button class="hvac-delete-account-submit" [hvacButton]="'primary'" [disabled]="!isConfirmCheckboxSelected" (click)="deleteAccountConfirmationModelVisible = true">
                <span>{{ 'USER_VALIDATION.SUBMIT' | translate }}</span>
            </button>
        </div>
    </form>



    <utc-modal class='hvac-delete-account-modal' size="dynamic-height" (closeAction)="deleteAccountConfirmationModelVisible = false" [visible]="deleteAccountConfirmationModelVisible" theme='rounded' [showHeader]="false">
        <div class="hvac-delete-account-wrapper">
            <h3 class="hvac-h3 hvac-warning-text">{{
                'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.DELETE_ACCOUNT_CONFIRMATION' | translate }}</h3>
            <p class="delete-account-modal-message">
                {{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.DELETE_ACCOUNT_MESSAGE' | translate }}
            </p>

            <ul class="hvac-systems-list">
                <li *ngFor="let system of systemsList">{{ system }}</li>
            </ul>

            <p class="delete-account-modal-message-bottom">
                {{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.CONFIRMATION_EMAIL_MESSAGE' | translate }}
            </p>

            <p class="delete-account-modal-message-bottom">
                {{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.PROCESSING_TIME_MESSAGE' | translate }}
            </p>

            <div class="hvac-divider hvac-button-divider"></div>
            <div class="hvac-delete-account-modal-actions">
                <button buttonType="button" hvacButton="default" (click)="deleteAccountConfirmationModelVisible= false;">
                    {{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.CANCEL' | translate }}
                </button>
                <button buttonType="button" hvacButton="primary" [disabled]="apiRequestActive" (click)="deletAccountRequest()">
                    {{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.DELETE_ACCOUNT' | translate }}
                </button>
            </div>

        </div>
    </utc-modal>
    <utc-loading-spinner variant="overlay" *ngIf="isLoading"></utc-loading-spinner>
</section>
